<template>
    <div class="label-wrapper">
        <span class="label">{{text}}</span>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {text: String}
    }
</script>

<style lang="scss" scoped>
    .label-wrapper {
        margin-bottom: .5em;

        .label {
            display: block;
            margin-bottom: .5em;
        }
    }
</style>